export const DecisionDateFormat = 'MMMM D, YYYY';
